module.exports = __webpack_public_path__ + "static/media/happy.69000288.png";